import React from 'react';
import { emptyFunction } from '../../utils/functions';
import { overlayStyle } from '../../utils/styles';
import './style.css';

const QuestionnaireThankYouModal = ({
  icon = emptyFunction,
  title = 'Thank You!',
  subtitle = 'Your questionnaire has been submitted successfully',
  // info = 'We have received your information and will process your car insurance inquiry. Our team will review your responses and get back to you with personalized quotes.',
  buttonText = 'Continue',
  onContinue = emptyFunction,
}) => (
  <div className="qt-modal-overlay" style={overlayStyle}>
    <div className="qt-modal-container">
      <div className="qt-modal-icon">
        {icon}
      </div>
      <div className="qt-modal-title">{title}</div>
      <div className="qt-modal-subtitle">{subtitle}</div>
      {/* <div className="qt-modal-info-box">{info}</div> */}
      <button className="qt-modal-continue-btn" onClick={onContinue}>{buttonText}</button>
    </div>
  </div>
);

export default QuestionnaireThankYouModal;
